import { createAction, handleActions } from 'redux-actions';
import * as func from "../../utils/functions";

const SET_RESOURCES = 'resource/SET_RESOURCES';
export const setResources = createAction(SET_RESOURCES);
const SET_RESOURCE = 'resource/SET_RESOURCE';
export const setResource = createAction(SET_RESOURCE);

// 초기 state를 정해줍니다
let initialState = {
  param : {
    'current_page' : 1,
    'record_per_page'  : 20,
    'ks' : '',
    'sub_ks' : '',
    'collabo_org' : [],
    'cited_count' : [],
    'resource_type' : [],
    'publisher' : [],
    'registered_db' : [],
    'dept' : [],
    'publish_year' : [],
    'scholar': [],
    'author_count' : [],
    'source_id' : '',
    'order_by' : 'publish_date',
    'order' : 'desc',
    'journal_id' : [],
    'not_resource_id' : '',
    'date_type' : 'input_date',
    'in_date_start' : '',
    'in_date_end' : '',
    'resource_status' : [],
    'scholar_id' : [],
    'worker_name' : '',
    'kri_no' : '',
    'dbid_no' : '',
    'sendmail_co': '',
    'sendmail_my': '',
  },
  records : [],
  checkedRecords : [],
  facet : {},
  totalRecords : 0,
  totalPage : 0,
  record : {},
  meta : {},
  fullText : [],
  isPopup1 : false,
  authorData : {},
  showSide : func.getCookie('side') === 'true' ? 'true' : 'false'
}

export default handleActions({
  [SET_RESOURCES]: (state, action) => {
    // console.log(state);
    action.payload = action.payload ? action.payload : {}
    return {
      ...state,
      param: {
        ...state.param,
        current_page : action.payload.param && action.payload.param.current_page ? action.payload.param.current_page : state.param.current_page,
        records_per_page : action.payload.param && action.payload.param.records_per_page ? action.payload.param.records_per_page : state.param.records_per_page,
        ks : action.payload.param && action.payload.param.ks ? action.payload.param.ks : state.param.ks,
        sub_ks : action.payload.param && action.payload.param.sub_ks ? action.payload.param.sub_ks : state.param.sub_ks,
        collabo_org : action.payload.param && action.payload.param.collabo_org ? action.payload.param.collabo_org : state.param.collabo_org,
        cited_count : action.payload.param && action.payload.param.cited_count ? action.payload.param.cited_count : state.param.cited_count,
        resource_type : action.payload.param && action.payload.param.resource_type ? action.payload.param.resource_type : state.param.resource_type,
        publisher : action.payload.param && action.payload.param.publisher ? action.payload.param.publisher : state.param.publisher,
        registered_db : action.payload.param && action.payload.param.registered_db ? action.payload.param.registered_db : state.param.registered_db,
        dept : action.payload.param && action.payload.param.dept ? action.payload.param.dept : state.param.dept,
        publish_year : action.payload.param && action.payload.param.publish_year ? action.payload.param.publish_year : state.param.publish_year,
        scholar : action.payload.param && action.payload.param.scholar ? action.payload.param.scholar : state.param.scholar,
        author_count : action.payload.param && action.payload.param.author_count ? action.payload.param.author_count : state.param.author_count,
        source_id : action.payload.param && action.payload.param.source_id ? action.payload.param.source_id : state.param.source_id,
        order_by : action.payload.param && action.payload.param.order_by ? action.payload.param.order_by : state.param.order_by,
        order : action.payload.param && action.payload.param.order ? action.payload.param.order : state.param.order,
        journal_id : action.payload.param && action.payload.param.journal_id ? action.payload.param.journal_id : state.param.journal_id,
        not_resource_id : action.payload.param && action.payload.param.not_resource_id ? action.payload.param.not_resource_id : state.param.not_resource_id,
        date_type : action.payload.param && action.payload.param.date_type ? action.payload.param.date_type : state.param.date_type,
        in_date_start : action.payload.param && action.payload.param.in_date_start ? action.payload.param.in_date_start : state.param.in_date_start,
        in_date_end : action.payload.param && action.payload.param.in_date_end ? action.payload.param.in_date_end : state.param.in_date_end,
        resource_status: action.payload.param && action.payload.param.resource_status ? action.payload.param.resource_status : state.param.resource_status,
        scholar_id: action.payload.param && action.payload.param.scholar_id ? action.payload.param.scholar_id : state.param.scholar_id,
        worker_name: action.payload.param && action.payload.param.worker_name ? action.payload.param.worker_name : state.param.worker_name,
        kri_no: action.payload.param && action.payload.param.kri_no ? action.payload.param.kri_no : state.param.kri_no,
        dbid_no: action.payload.param && action.payload.param.dbid_no ? action.payload.param.dbid_no : state.param.dbid_no,
        sendmail_my: action.payload.param && action.payload.param.sendmail_my ? action.payload.param.sendmail_my : state.param.sendmail_my,
        sendmail_co: action.payload.param && action.payload.param.sendmail_co ? action.payload.param.sendmail_co : state.param.sendmail_co,
      },
      records : action.payload.records ? action.payload.records : state.records,
      checkedRecords : action.payload.checkedRecords ? action.payload.checkedRecords : state.checkedRecords,
      facet : action.payload.facet ? action.payload.facet : state.facet,
      totalRecords : action.payload.pageInfo ? action.payload.pageInfo.totalResults : state.totalRecords,
      totalPage : action.payload.pageInfo ? action.payload.pageInfo.totalPage : state.totalPage,
      isPopup1 : action.payload.isPopup1,
    }
  },
  [SET_RESOURCE]: (state, action) => {
    return {
      ...state,
      record : action.payload.record ? action.payload.record : state.record,
      meta : action.payload.meta ? action.payload.meta : state.meta,
      fullText : action.payload.fullText ? action.payload.fullText : state.fullText,
      authorData : action.payload.authorData ? action.payload.authorData : state.authorData,
      showSide: action.payload.showSide ? action.payload.showSide : state.showSide,
    }
  },
}, initialState)
